module.exports = __webpack_public_path__ + "media/images/banner/category/feature/poj-banner-ddf01ed35c6072088657089adddde2b0.jpg";